/**
 * Takes a function that may be undefined and returns a function that will
 * return the return value of the original function, or return undefined if the
 * original function is undefined.
 */
export const maybeCall = <A extends unknown[] = unknown[], B = unknown>(
  fn?: (...args: A) => B
) => (...args: A): B | undefined => {
  return fn !== undefined ? fn(...args) : undefined;
};
